export default __webpack_public_path__ + "static/media/i-circle-fan.5835740e.svg";